import { Injectable } from "@angular/core";
import { HhsgSharedStuderApplicationLink } from "../../models/sgportal-data-api-models/application-link.model";
import { HhsgSharedConfigService } from "../config.service";
import { HhsgSharedHttpService } from "../http.service";

@Injectable()
export class HhsgSharedStuderApplicationService {
    private readonly _apiServer: string;
    private readonly _controllerName = "Application";

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.sgPortalApiServer;
    }

    public async getApplicationLinksForOrganization(organizationId: number): Promise<HhsgSharedStuderApplicationLink[]> {
        return await this._httpService.doGetRequestAsync<HhsgSharedStuderApplicationLink[]>(
            this._apiServer,
            this._controllerName, 
            `GetApplicationLinksForOrganization/${organizationId}`);
    }
}